import { NumberParam, StringParam } from "use-query-params";

// search params config
export const queryParamsConfig = {
  page: NumberParam,
  pageSize: NumberParam,
  search: StringParam,
  active: StringParam,
  sortDirection: NumberParam,
  sortColumn: StringParam,
};

export const initialFilter = {
  page: 1,
  pageSize: 15,
};
